import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const FileUploadIcon = (props) => {
  const { color } = props;
  return (
    <SvgIcon {...props}>
      <svg xmlns='http://www.w3.org/2000/svg' width='16.667' height='20.238' viewBox='0 0 16.667 20.238'>
        <path
          id='file_upload_24px'
          d='M9.762,18.476H16.9V11.333h4.762L13.333,3,5,11.333H9.762ZM5,20.857H21.667v2.381H5Z'
          transform='translate(-5 -3)'
          fill={color || '#d6d6d6'}
        />
      </svg>
    </SvgIcon>
  );
};
export default FileUploadIcon;
